import { render } from "./Matchmaker.vue?vue&type=template&id=9745fa04"
import script from "./Matchmaker.vue?vue&type=script&lang=js"
export * from "./Matchmaker.vue?vue&type=script&lang=js"

import "./Matchmaker.vue?vue&type=style&index=0&id=9745fa04&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__